/**
 * Filter 域类型权威定义。
 *
 * @canonical 5.3-domain-owned-types
 */

/** 筛选/过滤运算符：前后端契约合法取值集合。 */
export const Operation = {
  Include: 'include',
  Exclude: 'exclude',
  Between: 'between',
  Greater: 'greater',
  Less: 'less',
  GreaterOrEqual: 'greaterOrEqual',
  LessOrEqual: 'lessOrEqual',
  Equal: 'equal',
  NotEqual: 'notEqual',
  NotNul: 'notNull',
  Null: 'null',
} as const;

export type TOperation = (typeof Operation)[keyof typeof Operation];

/**
 * 筛选器 UI 形态 discriminant（存库 `filter_method` 数字协议）。
 *
 * @core 探索分析、AB 实验、SortableDrag 建图筛选区共用。
 */
export const FilterMethod = {
  None: 1,
  Time: 2,
  County: 3,
  String: 4,
  Number: 5,
  Package: 6,
  Date: 7,
  GroupCascade: 8,
} as const;

export type TFilterMethod = (typeof FilterMethod)[keyof typeof FilterMethod];

/** 筛选运算符下拉选项（含 i18n 展示文案）。 */
export interface IFilterOperationOption {
  value: TOperation | string;
  text: string;
  text_en: string;
}
